import * as Resource from './common/resource'
import * as Award from './common/award'
import lazyComponent from '@/components/common/lazyComponent'

export const comments = {
    lazyComponent
};

function install() {
    Object.keys(comments).forEach((key) => {
        Vue.component(key, comments[key]);
    });
    Vue.prototype.$Service = {
        resource: Resource,
        award: Award
    }
};

export default {
    install
}